module.exports = __webpack_public_path__ + "static/img/temp_bg.e8f6584c.png";